import React, { useState } from "react";
import axios from "axios";

const VoipSolContact = () => {
  // State to manage form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    comments: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbzv0q-Fp1yXGYYNYwC-xCibLqHJBEA2CnLyDxgfJftPqEjpRvgv6-I1wMyi3TG6-v5K/exec",
        {
          method: "POST",
          body: JSON.stringify(formData)
        }
      );

      if (response.status === 200) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          comments: "",
        });
      }
      setSuccessMessage("We’ve received your request successfully. Our team will be in touch with you shortly.");

    } catch (error) {
      console.error("Error sending message:", error);
      setErrorMessage("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="md:w-1/3  shadow-2xl rounded-2xl p-4 mt-10 lg:mt-10 md:mt-1 bg-white">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        Ready to Innovate?{" "}
        <span role="img" aria-label="rocket">
          🚀
        </span>
      </h2>
      <p className="text-gray-600 mb-6">
        Let’s create the next big thing together!
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter your name*"
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email*"
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
        <div className="flex flex-col md:flex-row md:space-x-2 items-center">
          <select
            className="w-full md:w-auto p-3 border rounded-lg focus:outline-none"
            value={formData.phone?.country || "IN"}
            onChange={(e) =>
              setFormData({
                ...formData,
                phone: { ...formData.phone, country: e.target.value },
              })
            }
          >
            <option value="IN">🇮🇳 +91</option>
            <option value="US">🇺🇸 +1</option>
          </select>
          <input
            type="tel"
            name="phone"
            value={formData.phone || ""}
            onChange={handleChange}
            placeholder="Mobile Number"
            className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 mt-4 md:mt-0"
          />
        </div>
        <input
          type="text"
          name="company"
          value={formData.company}
          onChange={handleChange}
          placeholder="Company name*"
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          required
        />
        <textarea
          name="comments"
          value={formData.comments}
          onChange={handleChange}
          placeholder="Any Comments"
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          rows="3"
        ></textarea>
        <button
          type="submit"
          className="w-full p-3 rounded-lg text-white bg-green-600 hover:bg-yellow-500 hover:text-black transition duration-300"
          disabled={loading}
        >
          {loading ? "Sending..." : "Send"}{" "}
          <span role="img" aria-label="send"></span>
        </button>
      </form>
      {/* Success and Error Messages */}
      {successMessage && (
        <p className="text-green-500 mt-4">{successMessage}</p>
      )}
      {errorMessage && <p className="text-red-500 mt-4">{errorMessage}</p>}
    </div>
  );
};

export default VoipSolContact;
